<template>
    <div class="joinUs">
      <mHead></mHead>
      <div class="main">
            <div class="img">
                <img v-for="(item, index) in imgListTop" :src="item.url" :key="index + 'top'" alt="">
            </div>
            <div class="logo">
                <img src="@/assets/img/CORANGE@2x.png" alt="">
                <p>加入青橙Family，我们一起<em>向上橙长</em></p>
            </div>
            <div class="jobDiv clear">
                <div class="left">
                    <div :class="'item ' + (item.sort == jobId?'on':'')" v-for="item in jobList" :key="item.sort" @click="changeItem(item)">
                        <p class="name">{{item.name}}</p>
                        <p class="time">{{item.sort == jobId?'更新于':''}}{{item.sort == jobId?item.time:'' | formatDate('yyyy.MM.dd')}}</p>
                    </div>
                </div>
                <div class="right" v-html="content">

                </div>
            </div>
            <!-- <div class="job" :style="'height: ' + jobImg.height + 'px;'">
                <img :style="'height: ' + jobImg.height + 'px;'" :src="jobImg.url" alt="">
                <div class="content">
                    <p class="title">
                        招聘岗位
                    </p>
                    <div class="filter">
                        <div>
                            <span class="lable">岗位类别：</span>
                            <span :class="'value ' + (selectTypeId == -1?'on' : '')" @click="filterJob('type', -1)">全部</span>
                            <span :class="'value ' + (selectTypeId == item.id?'on' : '')" v-for="(item , index) in typeList" :key="index+'type'"  @click="filterJob('type', item.id)">{{item.typeName}}</span>
                        </div>
                        <div>
                            <span class="lable">工作地点：</span>
                            <span :class="'value ' + (selectAddressId == -1?'on' : '')" @click="filterJob('address', -1)">全部</span>
                            <span :class="'value ' + (selectAddressId == item.id?'on' : '')" v-for="(item , index) in addressList" :key="index+'type'" @click="filterJob('address', item.id)">{{item.addressName}}</span>
                        </div>
                    </div>
                    <div class="table">
                        <div class="head">
                            <div class="item" style="width:184px;">岗位名称</div>
                            <div class="item" style="width:184px;">岗位类别</div>
                            <div class="item" style="width:170px;">招聘人数</div>
                            <div class="item" style="width:184px;">工作地点</div>
                        </div>
                        <div class="body" v-if="jobList.length > 0">
                            <div class="line" v-for="(item, index) in jobList" :key="index+'job'">
                                <div class="item" style="width:184px;">{{item.jobName}}</div>
                                <div class="item" style="width:184px;">{{item.typeName}}</div>
                                <div class="item" style="width:149px; padding-left: 30px;">{{item.userNum || 0}}</div>
                                <div class="item" style="width:184px;">{{item.addressName}}</div>
                            </div>
                        </div>
                        <div v-else class="noData">
                            暂无岗位
                        </div>
                    </div>
                </div>
            </div>
            <div class="imgDiv">
                <img v-for="(item, index) in imgListBottom" :style="'height: ' + item.height + 'px;'" :src="item.url" :key="index + 'bottom'" alt="">
            </div> -->
      </div>
      <mBottom></mBottom>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import mHead from '@/components/base/pc/mHead.vue'
import mBottom from '@/components/base/pc/mBottom.vue'
export default {
    components:{ mHead, mBottom },
    data() {
        return {
            imgListTop: [{
                // url: require('@/assets/img/joinUs.png')
            }],
            imgListBottom: [],
            jobImg: {
                url: ''
            },
            addressList: [],
            tableData: [],
            typeList: [],
            jobId: 0,
            content: '',
            jobList: [
                
            ],
            selectTypeId: -1,
            selectAddressId: -1
        }
    },
    computed: mapState({
    // 映射 this.count 为 store.state.count
       
        // swiper() {
        //     return this.$refs.mySwiper.swiper
        // },
    }),
    mounted(){
        this.getList();
        // this.getTableData();
        // this.getAddressList();
        // this.getTypeList();
        this.statistics();
    },
    methods: {
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '加入我们'} ).then(response =>{
              
            })
        },
        changeItem(item){
            this.jobId = item.sort;
            this.content = item.desc;
        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=5' ).then(response =>{
                if(response.status == 200){
                    let list = response.body || []
                    if(list.length > 0){
                        list.map(item => {
                            if(item.keyName == 'imgListTop'){
                                let urlList = item.content.split(',')
                                let heightList = item.keyDesc.split(',')
                                urlList.map((em,ind) => {
                                    this.imgListTop.push({ height: heightList[ind], url: em})
                                })
                            } else if(item.keyName == 'jobList'){
                                this.jobList = JSON.parse(item.content || '[]');
                                if(this.jobList.length > 0) {
                                    this.jobId = this.jobList[0].sort
                                    this.content = this.jobList[0].desc;
                                }
                            }

                            //  else if(item.keyName == 'imgListBottom'){
                            //     let urlList = item.content.split(',')
                            //     let heightList = item.keyDesc.split(',')
                            //     urlList.map((em,ind) => {
                            //         this.imgListBottom.push({ height: heightList[ind], url: em})
                            //     })
                            // } else if(item.keyName == 'jobImg') {
                            //     this.jobImg.url = item.content;
                            //     this.jobImg.height = item.keyDesc;
                            // }
                        })
                    }
                } else {
                    this.$message.error(response.message?response.message:'error');
                }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        getTableData(){
            let url = this.service.dev.api.jobList;
            this.$http.get(url).then(response =>{
                if(response.status == 200 && response.body ){
                    this.tableData = response.body || [];
                    this.jobList = response.body || [];
                }else{
                    this.tableData = [];
                    this.jobList = [];
                }
            }).catch((response) => {
            })
        },
        getAddressList(){
            let url = this.service.dev.api.addressList;
            this.$http.get(url).then(response =>{
                if(response.status == 200 && response.body ){
                    this.addressList = (response.body || []).filter(item => {
                        return item.status == 1;
                    });
                }else{
                    this.addressList = [];
                }
            }).catch((response) => {
            })
        },
        getTypeList(){
            let url = this.service.dev.api.jobTypeList;
            this.$http.get(url).then(response =>{
                if(response.status == 200 && response.body ){
                    this.typeList = (response.body || []).filter(item => {
                        return item.status == 1;
                    });
                }else{
                    this.typeList = [];
                }
            }).catch((response) => {
            })
        },
        filterJob(type, id) {
            if(type == 'type') {
                this.selectTypeId = id;
            } else {
                this.selectAddressId = id;
            }
            this.jobList = this.tableData.filter(item => {
                return (item.typeId == this.selectTypeId || this.selectTypeId == -1) && (item.addressId.split(',').indexOf(this.selectAddressId) > -1 || this.selectAddressId == -1)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .joinUs {
        background: #FAFAFA;
        min-width: 1080px;
        .main {
            min-width: 1000px;
            margin-top: 52px;
            .img {
                width: 100%;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .logo {
                padding: 104px 0;
                background: #ffffff;
                img {
                    width: 112px;
                    margin: 0 auto;
                    margin-bottom: 16px;
                }
                p {
                    font-size: 36px;
                    em {
                        color: #FF6600;
                        font-style: normal; 
                    }
                }
            }
            .jobDiv {
                width: 75%;
                margin: 0 auto;
                max-width: 1200px;
                .left {
                    width: 240px;
                    padding-top: 72px;
                    .item {
                        text-align: left;
                        margin-bottom: 24px;
                        cursor: pointer;
                        .name {
                            font-size: 24px;
                            color: rgba(0, 0, 0, 0.3);
                        }
                        .time {
                            font-size: 12px;
                            height: 16px;
                            line-height: 16px;
                            margin-top: 4px;
                        }
                        &.on,&:hover {
                            .name {
                                color: #000000;
                                font-weight: bold;
                            }
                        }
                    }
                }
                .right {
                    width: calc(100% - 242px);
                    height: 760px;
                    overflow-y: auto;
                    border-left: 2px solid #FFFFFF;
                    padding: 72px 120px 130px;
                    text-align: left;
                    box-sizing: border-box;
                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        opacity: 0.2;
                    }
                }
            }
            .job {
                width: 100%;
                position: relative;
                >img {
                    width: 100%;
                    position: absolute;
                    object-fit: none;
                    display: block;
                    top:0;
                    z-index: 0;
                }
                .content {
                    position: relative;
                    z-index: 1;
                    max-width: 1000px;
                    margin: 0 auto;
                    .title {
                        font-family: SourceHanSansCN-Regular;
                        font-size: 30px;
                        color: #ffffff;
                        margin-bottom: 12px;
                    }
                    .filter {
                        font-family: SourceHanSansCN-Bold;
                        color: #ffffff;
                        font-size: 18px;
                        text-align: left;
                        width: 800px;
                        margin: 0 auto;
                        >div {
                            margin-bottom: 12px;
                        }
                        .lable,.value {
                            display: inline-block;
                            padding: 0px 8px;
                            // width: 120px;
                        }
                        .lable {
                            text-align: right;
                            width: 100px;
                        }
                        .value {
                            text-align: left;
                            cursor: pointer;
                            margin-right: 40px;
                            &.on,&:hover {
                                background: #ff6900;
                            }
                        }
                    }
                    .table {
                        color: #ffffff;
                        font-size: 14px;
                        width: 800px;
                        margin: 40px auto 0;
                        font-family: SourceHanSansCN-Medium;
                        .head {
                            background: #f58436;
                            text-align: left;
                            .item {
                                padding: 6px 8px;
                                display: inline-block;
                                text-align: left;
                            }
                        }
                        .line {
                            &:nth-of-type(odd) {
                                background: #343434;
                            }
                            &:nth-of-type(even) {
                                background: #686868;
                            }
                            text-align: left;
                            .item {
                                padding: 6px 8px;
                                display: inline-block;
                                text-align: left;
                            }
                        }
                    }
                    .noData {
                        padding: 4px 0;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
   .joinUs {
        .main {
            .jobDiv {
                .right {
                    ol {
                        padding-left: 20px;
                        li {
                            font-size: 16px;
                            color: rgba(0,0,0,0.6);
                        }
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0,0,0,0.6);
                    }
                    h3,h4,h5,h2,h1 {
                        margin: 0;
                    }
                }
            }
        }
   }
</style>





// WEBPACK FOOTER //
// src/modules/view/joinUs/index.vue